<template>
  <div>
    <!-- CRUD ENTITY -->
    <crud-view
      :crudEndpoint="crudEndpoint"
      @add="edit()"
      @filters-updated="onFiltersUpdated"
      @reset-filters="resetFilters"
      :fields="fields"
      :filters="filters"
      ref="crudView"
    >
      <!-- FILTERS -->
      <template v-slot:filters>
        <filters
          v-model="filters"
          v-if="filtersUpdated"
        />
      </template>

      <!-- RESULTS -->
      <template v-slot:results="{ results, sortChanged, pageIndex }">
        <results
          :pageIndex="pageIndex"
          :results="results"
          :fields="fields"
          @edit="edit"
          @remove="remove"
          @sort-changed="sortChanged"
        />
      </template>
    </crud-view>

    <!-- MODAL -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      button-size="sm"
      size="lg"
      ref="modal"
      :lazy="true"
      :title="obj.id ? $gettext('edit') : $gettext('add')"
      @ok.prevent="save"
      >
      <template v-slot:modal-footer>
        <modal-buttons @save="save" @cancel="cancel" />
      </template>
      <ValidationObserver ref="modalForm" slim>
        <LocationForm
          v-model="obj"
          @save="save"
          :showEU="true"
          :iataCodeLength="3"
          :initialSubdivision="obj.subdivision ? obj.subdivision.name : null"
          :showSubdivision="true"
          @countrySelected="onCountrySelect"
          :initialCountry="obj.subdivision ? obj.subdivision.country.name : null"
          :showIataCode="true"
          :showCountry="true"
          :cities="true"
        />
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import CrudView from '@/shared/components/pages/CrudView.vue'

import Filters from './Filters.vue'
import Results from './Results.vue'
import LocationForm from '../countries/LocationForm.vue'

export default {
  components: {
    CrudView,
    Filters,
    Results,
    LocationForm,
  },
  data() {
    return {
      crudEndpoint: 'agency|city',
      filters: this.getDefaultFilters(),
      filtersUpdated: false,
      obj: {},
      fields: [
        { key: 'index', label: '', tdClass: 'td-index-class' },
        {
          key: 'name',
          label: this.$gettext('name'),
          stickyColumn: true,
        },
        {
          key: 'local_name',
          label: this.$gettext('local name'),
        },
        {
          key: 'country_subdivision',
          label: this.$gettext('country subdivision'),
        },
        {
          key: 'country',
          label: this.$gettext('country'),
        },
        {
          key: 'iata_code',
          label: this.$gettext('iata code'),
        },
        {
          key: 'is_eu',
          label: this.$gettext('is eu'),
          formatter: (val) => (val ? this.$gettext('yes') : this.$gettext('no')),
        },
        {
          key: 'active',
          label: this.$gettext('active'),
          formatter: (val) => (val ? this.$gettext('yes') : this.$gettext('no')),
        },
        {
          key: 'buttons',
          label: '',
        },
      ],
    }
  },
  computed: {
    api() {
      return this.crudEndpoint.split('|')
    },
  },
  methods: {
    onFiltersUpdated(e) {
      this.filters = e
      this.filtersUpdated = true
    },
    async onCountrySelect(country) {
      if (country) {
        if (!country.has_subdivisions) {
          const subdivisionRes = await this.$crud.agency.countrySubdivision
            .get({ params: { country: country.id } })

          const sub = subdivisionRes.items.find((el) => el.name === '_default')
          if (sub) this.obj.subdivision_id = sub.id

          this.obj.country_id = country.id
        }
        this.obj.country = country
      } else {
        this.obj.subdivision_id = null
      }
    },
    async edit(id) {
      if (id) this.obj = await this.$crud[this.api[0]][this.api[1]].get({ id })
      else {
        this.obj = {
          active: true,
          is_eu: false,
        }
      }

      this.$refs.modal.show()
    },
    async remove(id) {
      const accepted = await this.$confirmModal()

      if (accepted) {
        await this.$crud[this.api[0]][this.api[1]].delete({ id })

        this.resetSearch()

        this.$toastDeleteSuccess()
      }
    },
    async save() {
      const isValid = await this.$refs.modalForm.validate()

      if (isValid) {
        await this.$crud[this.api[0]][this.api[1]].save({ obj: this.obj, blocker: true })

        this.resetSearch()

        this.$toastSaveSuccess()

        this.cancel()
      } else {
        this.$toastInvalidForm()
      }
    },
    resetSearch() {
      this.resetFilters()
      this.$refs.crudView.search(true)
    },
    cancel() {
      this.$refs.modal.hide()
    },
    resetFilters() {
      this.filters = this.getDefaultFilters()
    },
    getDefaultFilters() {
      return {
        order: 'subdivision_id',
      }
    },
  },
}
</script>
